import { useEffect, useState } from "react";
import boutimeLogo from "../assets/bouttime-logo.svg";

export default function OfflineScreen() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline  = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener("online",  goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online",  goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (isOnline) return null;

  return (
    <>
      <style>{`
        @keyframes offlinePulse {
          0%, 100% { opacity: 1;    transform: scale(1); }
          50%       { opacity: 0.5; transform: scale(0.97); }
        }
      `}</style>
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "linear-gradient(180deg, #FAF3E8 0%, #F2E8D5 100%)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9998,
          fontFamily: "'Satoshi', sans-serif",
          gap: "20px",
          padding: "32px",
          textAlign: "center",
        }}
      >
        <img
          src={boutimeLogo}
          alt="Bout Time"
          style={{
            width: 100,
            animation: "offlinePulse 2s ease-in-out infinite",
          }}
        />

        <div>
          <div style={{
            fontFamily: "'Fraunces', Georgia, serif",
            fontSize: "24px",
            fontWeight: "700",
            color: "#1A1A1A",
            marginBottom: "8px",
          }}>
            You're offline
          </div>
          <div style={{
            fontSize: "15px",
            color: "#5A5A5A",
            lineHeight: 1.5,
          }}>
            Check your connection and try again
          </div>
        </div>
      </div>
    </>
  );
}
